import TextFilter from "./text-filter";

type FilterApply<Key extends string> = (key: Key, value: string | undefined) => void;

export function textFilterFactory<Key extends string>(
  applied: Partial<Record<Key, string>>,
  onApply: FilterApply<Key>,
): (
  filterKey: Key,
  placeholder: string,
  normalize?: (typed: string) => string | undefined,
) => JSX.Element {
  return (filterKey, placeholder, normalize) => (
    <TextFilter
      key={`${filterKey}:${applied[filterKey] ?? ""}`}
      filterKey={filterKey}
      placeholder={placeholder}
      applied={applied[filterKey]}
      normalize={normalize}
      onApply={onApply}
    />
  );
}
